<template>
  <div>
    <div>
      <p>
        Consistent spacing creates visual balance that makes the user interface (UI) easier for merchants to scan. Apply consistent spacing to improve the quality of the UI.
      </p>
    </div>
    <spacing-principles />
    <spacing-system />
    <spacing-applying />
  </div>
</template>

<script>
import SpacingPrinciples from './spacing/SpacingPrinciples.vue'
import SpacingSystem from './spacing/SpacingSystem.vue'
import SpacingApplying from './spacing/SpacingApplying.vue'

export default {
  components: {
    SpacingPrinciples,
    SpacingSystem,
    SpacingApplying,
  },
}
</script>
